// extracted by mini-css-extract-plugin
export default {"customRow":"Signup_customRow__hHjkG"};